import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  forwardRef,
  Input,
  OnInit,
  Output,
  ViewChild
} from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { Router } from '@angular/router';
import { ReuseTabService } from '@delon/abc/reuse-tab';
import { _HttpClient, SettingsService } from '@delon/theme';
import { NzSelectComponent } from 'ng-zorro-antd/select';

import { CustomerAddConfigService } from '../../inline-add-panel/customer-add-config.service';
import { SelectInstantBaseNewComponent } from '../selectInstant-base-new';

@Component({
  selector: 'app-customer-select',
  templateUrl: './customer-select.component.html',
  styles: [
    `
      /* ===== CONTAINER STYLES ===== */
      .customer-select-container {
        position: relative;
        width: 100%;
      }

      /* ===== ADD NEW BUTTON STYLES ===== */
      ::ng-deep .add-new-button {
        color: #000000 !important;
        font-weight: 500 !important;
        width: 100% !important;
        display: flex !important;
        align-items: center !important;
        justify-content: center !important;
        gap: 2px !important;
        background-color: transparent !important;
        border: none !important;
      }

      ::ng-deep .add-new-button .anticon {
        color: #000000 !important;
      }

      /* ===== OCR SUGGESTED ITEMS ===== */
      ::ng-deep .ocr-suggested-item {
        display: flex;
        align-items: center;
        gap: 8px;
        padding: 4px 0;
        cursor: pointer;
        width: 100%;
      }

      ::ng-deep .ocr-text {
        font-weight: 500;
        flex: 1;
      }

      /* ===== ULTRA COMPACT DROPDOWN STYLES ===== */
      ::ng-deep .ant-select-dropdown:has(app-customer-select-item) {
        max-height: none !important;
        overflow: hidden !important;
        width: 300px !important;
      }

      ::ng-deep
        .ant-select-dropdown:has(app-customer-select-item)
        .ant-select-dropdown-menu {
        max-height: 240px !important;
        overflow-y: auto !important;
        overflow-x: hidden !important;
      }

      ::ng-deep
        .ant-select-dropdown:has(app-customer-select-item)
        .ant-select-item-option {
        height: auto !important;
        min-height: 60px !important;
        padding: 6px 10px !important;
      }

      /* ===== CUSTOMER ITEM LAYOUT ===== */
      ::ng-deep .ant-select-dropdown app-customer-select-item {
        display: block !important;
        width: 100% !important;
        height: auto !important;
      }

      ::ng-deep .ant-select-dropdown app-customer-select-item .width-lg {
        display: block !important;
        width: 100% !important;
      }

      ::ng-deep
        .ant-select-dropdown
        app-customer-select-item
        .width-lg
        > div:first-child {
        display: flex !important;
        justify-content: space-between !important;
        align-items: center !important;
        width: 100% !important;
      }

      ::ng-deep .ant-select-dropdown app-customer-select-item nz-tag {
        display: inline-block !important;
        visibility: visible !important;
        opacity: 1 !important;
        margin-left: auto !important;
      }

      /* ===== SPECIAL OPTION HIGHLIGHTING ===== */
      ::ng-deep .ant-select-item-option-content .special-option {
        text-align: center !important;
      }

      /* ===== YELLOW HIGHLIGHT FOR SECOND ITEM ===== */
      ::ng-deep
        .dropdownSelect:not(:has(.ant-select-item-option-active))
        .ant-select-item-option:nth-child(2):not(
          .ant-select-item-option-active
        ):not(.ant-select-item-option-selected):not(:hover),
      ::ng-deep
        .dropdownSelect
        .ant-select-item-option:first-child:last-child:not(
          .ant-select-item-option-active
        ):not(.ant-select-item-option-selected):not(:hover) {
        background-color: #ffc000;
      }

      //  ::ng-deep .ant-select-dropdown:has(app-supplier-select-item) .ant-select-item-option:has(.section-label)  {
      //   height: auto !important;
      //   min-height: 20px !important;
      //   padding: 6px 10px !important;
      // }
    `
  ],
  standalone: false,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CustomerSelectComponent),
      multi: true
    }
  ]
})
export class CustomerSelectComponent
  extends SelectInstantBaseNewComponent
  implements OnInit, AfterViewInit
{
  @ViewChild('selector') nzSelectComponent!: NzSelectComponent;
  // @ViewChild('inlineAddPanel') inlineAddPanel!: InlineAddPanelComponent;

  @Input() valueToAdd: string = 'customer';

  @Output() readonly MoreDetailsClicked = new EventEmitter<any>();
  // showInlineAddPanel = false;
  customerConfig: any;
  inlineDefaults: any = null;
  // Store instant data separately to preserve it when dropdown closes
  // storedInstantData: string = '';

  //uds
  fromCode: string | null = null;
  toCode: string | null = null;

  activeOnly: boolean = true;

  constructor(
    http: _HttpClient,
    router: Router,
    cdr: ChangeDetectorRef,
    private resueTabService: ReuseTabService,
    private customerAddConfigService: CustomerAddConfigService,
    private settingsService: SettingsService
  ) {
    super(http, cdr, router);
  }

  @Input() selectDisabled: boolean = false;

  @Input() tabindex: string | null = null;

  @Input() labelField: 'name' | 'full' | null = null;

  @Input() nzAllowClear: boolean = true;

  @Output() readonly addNewCustomer = new EventEmitter<any>();

  NotShowInReport: boolean = false;

  ngOnInit(): void {
    this.checkAddNewOptionInReportAccess();
    this.customerConfig = this.customerAddConfigService.getCustomerConfig();
    //this.valueField = 'id'; // Set the value field to 'id'

    // Listen to search form changes to store instant data
    this.searchForm.controls.keyword.valueChanges.subscribe(value => {
      if (value) {
        const trimmedValue = value.trim();
        this.storedInstantData = trimmedValue;
        // Also store in pendingInstantData for Add New (handled by base class)
        this.pendingInstantData = trimmedValue;
      }
    });

    // Ensure the correct item is active whenever the list updates while open
    this.onListFilled.subscribe(() => {
      if ((this.nzSelectComponent as any)?.nzOpen) {
        this.ensureFirstItemActivatedAndFocused();
      }
    });
  }

  ngAfterViewInit(): void {
    if (this.tabindex) {
      const nzSelectElement =
        this.nzSelectComponent.originElement.nativeElement;
      const searchInput = nzSelectElement.querySelector('input');

      if (searchInput) {
        searchInput.setAttribute('tabindex', this.tabindex?.toString() || '0');

        // Listen to input events directly
        searchInput.addEventListener('input', (event: any) => {
          if (event.target.value) {
            const trimmedValue = event.target.value.trim();
            this.storedInstantData = trimmedValue;
            // Also store in pendingInstantData for Add New (handled by base class)
            this.pendingInstantData = trimmedValue;
          }
        });
      }
    }
  }

  getLabel(item: any) {
    if (item) {
      if (this.labelField === 'name') return item.name;
      else if (this.labelField === 'full') return `${item.code} - ${item.name}`;
      return item.code;
    }
    return '';
  }

  override valueChanged(val: any, isInstantData: boolean = false): void {
    // Prevent selecting '__addnew__' option (null value) when in report pages
    if (val === null && this.NotShowInReport) {
      // Clear the selection instead of allowing null
      this.value = null;
      this.selected = null;
      this.onChange(null);
      this.selectedChange.emit(null);
      return;
    }
    // Call parent implementation for normal selections
    super.valueChanged(val, isInstantData);
  }

  override addNew(): void {
    // Use pendingInstantData which was captured synchronously in base class onAddNewClick
    // This ensures we have the data even if storedInstantData was cleared
    const instantDataToUse = this.pendingInstantData || this.storedInstantData;

    // If we still don't have data, try to capture it
    if (!instantDataToUse) {
      this.captureCurrentSearchValue();
      const currentSearchValue = this.getCurrentSearchValue();
      if (currentSearchValue) {
        this.pendingInstantData = currentSearchValue;
      }
    }

    // Final fallback - use whatever we have
    const finalInstantData = this.pendingInstantData || this.storedInstantData || '';
    
    // Load defaults first, then show panel
    this.fetchInlineDefaults().then(
      () => {
        // Merge instant data into initialData as fallback
        // Note: customer config uses 'name' field for instant data, not 'code'
        if (finalInstantData) {
          this.inlineDefaults = { ...this.inlineDefaults, name: finalInstantData };
        }
        
        this.showInlineAddPanel = true;
        // Force change detection to ensure the panel is rendered
        this.cdr.detectChanges();
        
        // Retry mechanism to ensure changeInstantData is called after form is ready
        const trySetInstantData = (retries: number = 10) => {
          if (!finalInstantData) return;
          
          if (this.inlineAddPanel && this.inlineAddPanel.formGroup) {
            const instantFieldName = this.customerConfig?.fields?.find((f: any) => f.isInstantData)?.name || 'name';
            const control = this.inlineAddPanel.formGroup.get(instantFieldName);
            if (control) {
              this.inlineAddPanel.changeInstantData(finalInstantData);
              return;
            }
          }
          
          if (retries > 0) {
            setTimeout(() => trySetInstantData(retries - 1), 50);
          }
        };
        
        // Try immediately and with retries
        setTimeout(() => {
          if (this.inlineAddPanel && finalInstantData) {
            this.inlineAddPanel.changeInstantData(finalInstantData);
          }
          trySetInstantData();
        }, 0);
        
        if (this.selector) {
          this.selector.setOpenState(false);
        }
      }
    );
  }
 

  //with uds
  getUrl(searchValue: string): string {
    let filter = `status in ('ACTIVE')`;

    if (this.activeOnly === false) {
      filter = '';
    }

    let url = `api/customers/search?$count=false&$top=50&$skip=0`;

    if (filter) {
      url = `${url}&$filter=${filter}`;
    }

    if (searchValue && String(searchValue).trim()) {
      url = `${url}&keyword=${encodeURIComponent(String(searchValue).trim())}`;
    } else {
      url = `${url}&$orderby=code asc`;
    }

    // Add fromCode and toCode if available
    if (this.fromCode && this.toCode) {
      filter += ` and (code ge '${this.fromCode}' and code le '${this.toCode}')`;
    }

    return url;
  }


  // set the location want to navigate
  jump(): string {
    return '/ar/customer/detail/0';
  }

  // set the param
  queryParam(): String {
    return 'CustName';
  }

  checkAddNewOptionInReportAccess(): boolean {
    let curUrl = this.resueTabService.curUrl.toLowerCase();

    if (curUrl.includes('report') || curUrl.includes('einv/')) {
      this.NotShowInReport = true;
    } else {
      this.NotShowInReport = false;
    }

    return this.NotShowInReport;
  }

  onCustomerSaved(customerData: any): void {
    // Create the customer object in the expected format
    const customer = {
      id: customerData.id,
      code: customerData.customerCode, // Use the new field name
      name: customerData.name,
      controlAccount: customerData.controlAccount,
      currency: customerData.currency,
      term: customerData.term,
      // Add properties that InvoiceService expects
      defaultWVatCodeId: customerData.defaultWVatCodeId || null,
      isGovBirCategory: customerData.isGovBirCategory || false
    };

    // Add the new customer to the list and select it
    this.list.unshift(customer);

    // Set the customer object directly in the form control
    if (this.valueToAdd === 'customer') {
      this.onChange(customer);
      this.writeValue(customer);
    } else if (this.valueToAdd === 'customerId') {
      this.onChange(customer.id);
      this.writeValue(customer.id);
    }
    this.selectedChange.emit(customer);
    this.showInlineAddPanel = false;
    this.cdr.detectChanges();
  }

  onCustomerCreated(event: { item: any; selectionConfig?: any }): void {
    if (event.item && event.selectionConfig) {
      // Create the customer object in the expected format
      const customer = {
        id: event.item[event.selectionConfig.valueField],
        code: event.item.code || event.item.customerCode,
        name: event.item[event.selectionConfig.labelField],
        controlAccount: event.item.controlAccount,
        currency: event.item.currency,
        term: event.item.term,
        // Add properties that InvoiceService expects
        defaultWVatCodeId: event.item.defaultWVatCodeId || null,
        isGovBirCategory: event.item.isGovBirCategory || false
      };

      // Add the new customer to the list and select it
      this.list.unshift(customer);

      // Close the inline panel first
      this.showInlineAddPanel = false;

      // Set the customer object in the form control to trigger customer.valueChanges
      this.value = customer.id;
      this.selected = customer.id;

      // Set the customer object directly in the form control
      if (this.valueToAdd === 'customer') {
        this.onChange(customer);
        this.writeValue(customer);
      } else if (this.valueToAdd === 'customerId') {
        this.onChange(customer.id);
        this.writeValue(customer.id);
      }
      // Emit addNewCustomer event for parent component to handle
      this.addNewCustomer.emit(customer);

      // Clear stored instant data after successful creation
      this.clearStoredInstantData();

      // Force change detection
      this.cdr.detectChanges();
    }
  }

  onCustomerCancelled(): void {
    this.showInlineAddPanel = false;
    this.clearStoredInstantData();
  }

  onCustomerMoreDetails(): void {
    // Navigate to customer details page with all the current form data
    const formData = this.inlineAddPanel?.formGroup?.value;
    if (formData) {
      // Create query params with all form fields
      const queryParams: any = {
        autoPopulate: 1
      };

      // Add all form fields to query params
      if (formData.name) queryParams.CustName = formData.name;
      if (formData.controlAccountId)
        queryParams.ControlAccountId = formData.controlAccountId;
      // if (formData.customerCode)
      //   queryParams.CustomerCode = formData.customerCode;
      if (formData.currencyId) queryParams.CurrencyId = formData.currencyId;
      if (formData.termId) queryParams.TermId = formData.termId;
      if (formData.agentId) queryParams.AgentId = formData.agentId;
      if (formData.areaId) queryParams.AreaId = formData.areaId;

      queryParams.autoPopulate = 1;

      this.router.navigate(['/ar/customer/detail/0'], {
        queryParams: queryParams
      });
    } else {
      this.router.navigate(['/ar/customer/detail/0'], {
        queryParams: {
          autoPopulate: 1
        }
      });
    }
    this.showInlineAddPanel = false;
    this.MoreDetailsClicked.emit();
    this.clearStoredInstantData();
  }

  private fetchInlineDefaults(): Promise<void> {
    // Call server to get defaults similar to cust/detail new()
    return new Promise(resolve => {
      this.http.get('api/customers/new').subscribe({
        next: (data: any) => {
          const defaults: any = {};
          if (data?.controlAccountId)
            defaults.controlAccountId = data.controlAccountId;
          if (data?.currencyId) defaults.currencyId = data.currencyId;
          if (data?.termId) defaults.termId = data.termId;
          if (data?.agentId) defaults.agentId = data.agentId;
          // Map object variants to ids
          if (!defaults.controlAccountId && data?.controlAccount?.id)
            defaults.controlAccountId = data.controlAccount.id;
          if (!defaults.currencyId && data?.currency?.id)
            defaults.currencyId = data.currency.id;
          if (!defaults.termId && data?.term?.id)
            defaults.termId = data.term.id;
          if (!defaults.agentId && data?.agent?.id)
            defaults.agentId = data.agent.id;
          this.inlineDefaults = defaults;
          resolve();
        },
        error: () => {
          this.inlineDefaults = null;
          resolve();
        }
      });
    });
  }
}
